import React from 'react';
import './App.css';
import { Router } from '@reach/router';
import Week from './components/Week';
import Day from './components/Day';
import Month from './components/Month';
import Signup from './components/Signup';
import Budget from './components/budget';
import NotFound from './components/NotFound';
import Account from './components/account';
import { withFirebase } from './components/Firebase'
import LoginPage from './components/Login';
import AdminPage from './components/admin';



const INITIAL_STATE = {
  currentUser: null,
  email: null,
  budget: null,
  spent: [],
}

let UserContext = React.createContext();

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
      email: null,
      budget: null,
      spent: [],
    }
  };

  componentDidMount() {
    this.getUserData();
  }
  componentWillUnmount() {
    this.getUserData()
  }

  resetState() {
    this.setState({ ...INITIAL_STATE })
  }

  getUserData () {
     this.props.firebase.auth.onAuthStateChanged(user => {
      if (user) {
        this.setState({ currentUser: user.uid });
        this.props.firebase.user(user.uid).child('email').on('value', snapshot => {
          this.setState({ email: snapshot.val() })
        })
        this.props.firebase.user(user.uid).child('budget').on('value', snapshot => {
          this.setState({ budget: snapshot.val() })
        })
      } else {
        this.setState({ ...INITIAL_STATE })
      } 
     })
  }

  render() {
    return  (
      <div className="App">
        <UserContext.Provider value={this.state}>
        <Router>
          <PrivateRoute 
            as={Week} 
            path='/' 
            budget={this.state.budget}
            user={this.state.currentUser}
            action={this.resetState}
          />
          <PrivateRoute 
            as={Day} 
            path='/day'
            budget={this.state.budget}
            user={this.state.currentUser}
            action={this.resetState} 
          />
          <PrivateRoute 
            as={Month} 
            path='/month'
            budget={this.state.budget}
            user={this.state.currentUser}
            action={this.resetState} 
          />
          <Signup path='/signup' />
          <Budget path='/budget' user={this.state.currentUser}/>
          <Account path='/account' email={this.state.email} user={this.state.currentUser} />
          <LoginPage path='/login' />
          <AdminPage path='/admin' />
          <NotFound default />
        </Router>
        </UserContext.Provider>
      </div>
  );
  }
}



class PrivateRoute extends React.Component {
  static contextType = UserContext;

  render() {
    let { as: Comp, ...props} = this.props;
    return this.context.currentUser ? <Comp {...props} /> : <Signup />;
  }
}



export default withFirebase(App);
